import { ApiPriceBookProduct } from '@vend/types'

import { $q } from '../../ng-compat/imports'
import { EntityStore } from './entity-store'

/**
 * Stores information on the retailer's price book products.
 */
class PriceBookProductsStore extends EntityStore<'priceBookProducts'> {
  constructor() {
    'ngInject'
    super({
      entityStoreName: 'priceBookProducts',
      entityName: 'price_book_products',
    })
  }

  /**
   * Get pricebook product information from the store that match given product id.
   *
   * @param productId
   *          The ID of the product to retrieve related pricebook products from the database
   *
   * @return A promise resolved with the requested pricebook products details
   */
  public getByProductId(productId: string) {
    return $q.resolve(this.dbStore.index('byProductId').getAll(productId))
  }

  /**
   * Determine whether the given price book product should be saved to the IndexedDB store or removed. Price
   * book products with a null `price_book_id` property (indicative of a hard delete) will be removed from the
   * IndexedDB store.
   *
   * @param  entityData
   *         The data for the price book product entity as returned by the API end point
   *
   * @return true if the entity should be stored, false if it should be removed
   */
  protected shouldStoreEntity(entityData: ApiPriceBookProduct) {
    return entityData.price_book_id !== null
  }
}

export const priceBookProductsStore = new PriceBookProductsStore()
